// Substrate fixed, field re-evaluated every frame. 52 of the 82 chapters work
// this way: the frame is a pure function of (seed, t), so it scrubs, exports
// frame-exact, and needs no warm-up.
import { push } from '../drawlist.js'
import { inPlane } from './shift.js'

export default {
  id: 'resample',
  label: 'Resample',
  stateful: false,

  // wantGradient is decided upstream by needsGradient(mark, motion): the
  // gradient is four extra field samples per point, so it is only computed
  // when an orientable mark is actually aligned to the flow.
  fill(list, substrate, field, cfg, motion, t, wantGradient) {
    const p = substrate.points
    const spin = t * motion.spin
    const fromValue = motion.align === 'field'
    const shift = motion.shift
    for (let i = 0; i < substrate.count; i++) {
      const o = i * 3
      const x = p[o], y = p[o + 1]
      const v = field.sample(x, y, t)
      const grad = wantGradient ? field.gradient(x, y, t) : 0
      const base = wantGradient ? grad : fromValue ? v : 0
      // Sampled where the substrate put it, drawn where the field pushes it.
      const d = shift ? inPlane(motion.axis, x, y, v * shift, grad) : null
      // Height field: the substrate's own z plus the sample, which is the
      // dominant idiom in the corpus — chapter 01 reads interference as height.
      push(list, d ? d.x : x, d ? d.y : y, p[o + 2] + v * motion.displace, v,
        base * motion.twist + spin, 1)
    }
  },
}
